import React, { useState } from "react";
import { Modal } from "react-bootstrap";

export function SubscriptionsPopup({ configuration, show, onHide }) {
  const [formData, setFormData] = useState({
    name: "",
    phone_number: "",
    email: "",
  });
  console.log(configuration);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  let subscriptionField = "";

  if (configuration.subscriptionField == "email") {
    subscriptionField = (
      <>
        <div className="mb-3">
        <label htmlFor="email_subscription" className="form-label fw-bold">
            {configuration.translations.emailLabel}
          </label>
          <input
            id="email_subscription"
            className="form-control "
            type="email"
            name="email"
            placeholder={configuration.translations.emailLabel}
            value={formData.email}
            onChange={handleChange}
            required
          />

        </div>
      </>
    );
  } else if (configuration.subscriptionField == "phone") {
    subscriptionField = (
      <>
        <div className="mb-3">
          <label htmlFor="phone_number" className="form-label fw-bold">
            {configuration.translations.phoneRegexMsg}
          </label>
          <input
            id="phone_number"
            className="form-control"
            type="tel"
            name="phone_number"
            placeholder={configuration.translations.phoneNumberLabel}
            pattern="^\+?1?\d{9,15}$"
            title={configuration.translations.phoneRegexMsg}
            value={formData.phone_number}
            onChange={handleChange}
            required
          />
        </div>
      </>
    );
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    const url = "/api/v1/subscriptions/";
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": OsoigoNext.getCookie("csrftoken"),
      },
      body: JSON.stringify(formData),
    };

    fetch(url, options)
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.json();
      })
      .then((data) => {})
      .catch((error) => {})
      .finally(() => {
        onHide();
      });
  };

  return (
    <Modal show={show} onHide={onHide} id="subscriptions-modal">
      <Modal.Header closeButton>
        <Modal.Title>
          {configuration.translations.subscriptionsTitle}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p>{configuration.translations.subscriptionsDescr}</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-bold" htmlFor="subscriptions-modal-name">
              {configuration.translations.nameLabel}
            </label>
            <input
              className="form-control"
              id="subscriptions-modal-name"
              type="text"
              name="name"
              placeholder={configuration.translations.nameLabel}
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          {subscriptionField}
          <div className="form-check mt-5">
            <input
              id="share_info"
              className="form-check-input"
              type="checkbox"
              name="share_info"
              required
            />
            <label
              className="form-check-label"
              htmlFor="share_info"
              dangerouslySetInnerHTML={{
                __html: configuration.translations.termsText,
              }}
            ></label>        
          </div>
          <div className="d-flex align-items-center justify-content-center">
            <button className="btn btn-primary mt-4" type="submit">
              {configuration.translations.subscribeButton}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
